<template>
  <div>
    <CrudList
      title="Traker Spots"
      storeName="Trakers_spot"
      parentStoreName="Trakers"
      parentUrlKey="spot_id"
      sortable
      canSearch
      :canAdd="false"
      :canEdit="false"
      :canDelete="true"
      labelBack="Atrás"
      :breadcrumbs="[
        {
          text: 'Reservas y estadías',
          disabled: false,
          href: '/admin/trakers'
        },
        {
          text: 'Traker Spots',
          disabled: false,
          href: '#'
        },
      ]"
    >
      <template v-slot:driver="{ item }">
        <v-row class="pt-2 ms-1">
          {{ item.driver && item.driver.user ? ((item.driver.user.name || "") + " " + (item.driver.user.last_name || "")) : "" }}
        </v-row>
      </template>
      <template v-slot:car="{ item }">
        <v-row class="pt-2 ms-1">
          {{item.driver && item.driver.patent ? item.driver.patent : ""}}
        </v-row>
      </template>
      <template v-slot:created_at="{ item }">
        <v-row class="pt-2 ms-1">
          {{ formatDateTimeUtc3(item.created_at) }}
        </v-row>
      </template>
      
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import CrudFormMixin from "@/mixins/crud_form";
  export default {
    components: {CrudList},
    mixins: [CrudFormMixin],
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },
    },
  };
</script>
